/* eslint-disable max-lines */
/* eslint-disable new-cap */
import React, { useEffect, useState } from 'react'
import Banner from '../components/organisms/Banner'
import EmptyDiv from '../components/EmptyDiv/EmptyDiv'
import Footer from '../components/Footer/Footer'
import HowItWorks from '@site/components/organisms/HowItWorks'
import Menu from '../components/Menu/Menu'
import Newsletter from '../components/Newsletter/Newsletter'
import { graphql } from 'gatsby'
import VideoSection from '@site/components/organisms/VideoSection'
import CookiesFab from '@site/components/organisms/CookiesFab'
import Faq from '@site/components/organisms/Faq'
import SubscriptionOffer from '@site/components/organisms/SubscriptionOffer'
import CommomHead from '@shared/meta/CommonHead'
import CompareClubsSection from '@site/components/organisms/CompareClubsSection/CompareClubsSection'
import StrapiService from '../../../shared/utils/strapi/strapi.service'
import CarouselSection from '@site/components/organisms/CarouselSection'
import { HomeProvider } from '@site/contexts/homeContext'

export function Head() {
  return <CommomHead />
}

export default function Home( { data }: Record<string, any> ) {
  const [ newBanner, setNewBanner ] = useState<any>( null )
  const [ clubs, setClubs ] = useState<any>( null )
  const [ faqs, setFaqs ] = useState<any>( null )
  const [ compareClubs, setCompareClubs ] = useState<any>( null )
  const [ howTagWorks, setHowTagWorks ] = useState<any>( null )
  const [ homeCarousel, setHomeCarousel ] = useState<any>( null )
  const [ renderAllElements, setRenderAllElements ] = useState( false )
  const [ isLoadingContent, setIsLoadingContent ] = useState( true )

  const isProd = process.env[ 'GATSBY_ACTIVE_ENV' ] === 'prd'

  async function fetchData() {
    if ( isProd ) {
      const { allStrapiHomes, allStrapiFaq } = data
      const [ homesNode ] = allStrapiHomes.nodes

      setNewBanner( homesNode.newBanner )
      setClubs( homesNode.clubs )
      setHowTagWorks( homesNode.homeHowTagWorks )
      setCompareClubs( homesNode.compareClubs )
      setHomeCarousel( homesNode.homeCarousel )
      setFaqs( allStrapiFaq.edges )
      setIsLoadingContent( false )
    } else {
      const strapiService = new StrapiService()
      const [
        homes,
        faqsData,
      ] = await Promise.all( [
        strapiService.getAllStrapiHomes(),
        strapiService.getStrapiFaqsFilteredByDisplay( { 'home': true } ),
      ] )
      const [ homeData ] = homes

      setNewBanner( homeData?.newBanner )
      setClubs( homeData?.clubs )
      setHowTagWorks( homeData?.homeHowTagWorks )
      setHomeCarousel( homeData?.homeCarousel )
      setCompareClubs( homeData?.compareClubs )
      setFaqs( faqsData.map( faq => ( { 'node': faq } ) ) )
      setIsLoadingContent( false )
    }
  }

  useEffect( () => {
    fetchData()
  }, [] )

  function handleAllElements() {
    setRenderAllElements( true )
  }

  if ( isLoadingContent ) {
    return null
  }

  return (
    <HomeProvider>
      <Menu />
      <Banner banners={ newBanner } />
      <EmptyDiv handleAllElements={ handleAllElements } />
      {renderAllElements ? (
        <>
          <VideoSection show={ false } />
          { howTagWorks ?
            <HowItWorks
              page="home"
              homeHowItWorks={ howTagWorks }
            />
            : null }
          { compareClubs ? <CompareClubsSection compareClubs={ compareClubs } /> : null }
          { homeCarousel ? <CarouselSection homeCarousel={ homeCarousel } /> : null }
          <SubscriptionOffer { ...clubs } />
          <Newsletter />
          <Faq faqs={ faqs } />
          <Footer />
        </>
      ) : (
        <div style={{ 'height': '500px' }} />
      )}
      <CookiesFab />
    </HomeProvider>
  )
}

export const query = graphql`
  query {
    allStrapiHomes(limit: 1, sort: { order: DESC, fields: strapiId }) {
      nodes {
        newBanner {
          button {
            backgroundColor
            hoverColor
            link
            text
            textColor
          }
          clock {
            active
            backgroundColor
            borderColor
            date
            textColor
          }
          image {
            desktop5000x1600 {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
                }
              }
            }
            mobile1200x1200 {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
                }
              }
            }
          }
          subtitle {
            color
            style
            text
          }
          title {
            color
            style
            text
            weight
          }
          warning {
            text
            color
          }
          containerAlign {
            align
          }
          bannerLink {
            link
          }
          color {
            backgroundColor
          }
        }
        clubs {
          subtitle
          title
          image {
            mobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
                }
              }
            }
            desktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
                }
              }
            }
          }
          description
          price
          cta {
            text
            link
          }
          footer
        }
        homeHowTagWorks {
          buttonBenefitsText
          buttonBenefitsUrl
          colorText
          colorTextColumn
          id
          subtitle
          title
          column {
            id
            imageAlt
            subtitle
            title
            image {
              url
            }
          }
        }
        homeCarousel {
          title
          subtitle
          autoPlay
          images {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
              }
            }
          }
        }
        compareClubs {
          title
          subtitle
          plans {
            selectTitle
            discountTag
            cards {
              backgroundColor
              detailsColor
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
                  }
                }
              }
              text
              originalPrice
              price
              gift
              giftIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
                  }
                }
              }
              primaryCta
              primaryCtaLink
              secondaryCta
              secondaryCtaLink
            }
          }
          infoTags {
            title
            titleColor
            infoTags {
              text
              icon {
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
                  }
                }
              }
            }
          }
        }
      }
    }
    allStrapiFaq(filter: { display: { home: { eq: true } } }, sort: { order: ASC, fields: strapiId }) {
      edges {
        node {
          eventLabel
          question
          answer
        }
      }
    }
  }
`
